<template>
	<div id="questionnaireDataStatisticsEdit">
		<div class="layout-content">
			<!-- 标题面包屑 -->
			<div class="layout-content-title">
				<div class="breadcrumb">
					<svg
						class="iconpark-icon"
						@click="to({ path: `/questionnaireDataStatistics/${surveyId}?oldMark=${oldMark}` })"
					>
						<use href="#fanhui"></use>
					</svg>
					<el-breadcrumb separator-class="el-icon-arrow-right">
						<el-breadcrumb-item :to="{ path: '/' }"> 报名表列表 </el-breadcrumb-item>
						<el-breadcrumb-item
							:to="{ path: `/questionnaireDataStatistics/${surveyId}?oldMark=${oldMark}` }"
						>
							数据统计
						</el-breadcrumb-item>
						<el-breadcrumb-item>查看详情</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
			</div>
			<div class="layout-container"></div>
		</div>
		<el-row class="footer">
			<div class="footerContent">
				<div class="footerContentInner">
					<!-- <el-col class="left"> -->
					<!-- <el-button v-if="isHandle" type="primary" @click="editHandle">编辑</el-button> -->
					<!-- <el-button v-else @click="dialogVisible = true">保存</el-button> -->
					<!-- </el-col> -->
					<el-col class="right">
						<p @click="nextHandle">
							<svg class="icon icon1" aria-hidden="true">
								<use xlink:href="#icon-xiayixiang" />
							</svg>
							下一项
						</p>
						<p @click="prevHandle">
							<svg class="icon icon1" aria-hidden="true">
								<use xlink:href="#icon-shangyixiang" />
							</svg>
							上一项
						</p>
					</el-col>
				</div>
			</div>
		</el-row>
		<el-dialog :visible.sync="dialogVisible" title="保存更改" width="420px">
			<span>是否保存更改</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="cancelSave">取 消</el-button>
				<el-button type="primary" @click="editQuestionnaire">保 存</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
// import questionnairePreview from '@/components/questionnaireVote';
import { surveyAnswer, answerReport } from '@/services';
import env from '@/config';

export default {
	components: {
		// questionnairePreview,
	},
	data() {
		return {
			surveyId: null, //问卷id
			source: '', //问卷唯一标识
			dialogVisible: false,
			sourceList: [],
			sourceIndex: null,
			isHandle: false, //投票结果是否可编辑
			nextSubmit: false, //下一项保存跳转
			prevSubmit: false, //上一项保存跳转
			qcodeShow: false, //二维码是否显示
			oldMark: '1', // 是否为旧版本问卷
		};
	},
	async created() {
		this.surveyId = this.$route.params.id;
		this.source = this.$route.params.source;
		const handle = this.$route.params.handle;
		this.oldMark = this.$route.params.oldMark;
		if (handle === 'show') {
			this.isHandle = true;
		}
		this.init();
	},
	async mounted() {
		const parcelProps = {
			serviceConfig: {
				local: process.env.NODE_ENV == 'development',
				apiPath: `${env.apiPath}/`,
				uploadPath: env.uploadHost,
				backendPath: `${env.Host}`,
				env: env.env,
			},
			domElement: document.querySelector('.layout-container'),
			parentVm: this,
			surveyId: this.$route.params.id,
			mode: 'pc',
			disabled: true,
			fillIn: true,
			oldMark: Boolean(Number(this.oldMark)),
			source: this.source,
		};
		const spa = await System.import('single-spa');
		this.parcel = spa.mountRootParcel(System.import('questionnaire'), parcelProps);
	},
	destroyed() {
		this.parcel.unmount();
	},
	methods: {
		to(routeInfo) {
			this.$router.push(routeInfo);
		},
		async init() {
			if (Number(this.oldMark)) {
				surveyAnswer.getSourceList(this.surveyId).then(({ ok, data }) => {
					if (ok) {
						this.sourceList = data.data.data;
						this.sourceList.forEach((item, index) => {
							if (item.source == this.source) {
								this.sourceIndex = index;
							}
						});
					}
				});
			} else {
				const { data, ok } = await answerReport.getSourceList(this.surveyId);
				if (!ok) {
					return;
				}
				this.sourceList = data.data.records;
				this.sourceList.forEach((item, index) => {
					if (item.id == this.source) {
						this.sourceIndex = index;
					}
				});
			}
		},
		//保存修改
		editQuestionnaire() {
			const source = this.$route.params.source;
			console.log(source);
			this.$refs.questionnairePreview.submitForm(source);

			//下一项保存完后跳转

			if (this.nextSubmit) {
				this.sourceIndex = this.sourceIndex + 1;
				console.log(this.sourceIndex);
				const source = this.sourceList[this.sourceIndex].source;
				this.$router.push({
					name: 'questionnaireDataStatisticsEdit',
					params: {
						id: this.surveyId,
						source: source,
						handle: 'show',
					},
				});
				this.$refs.questionnairePreview.createdHandle();
				this.isHandle = true;
			}
			//上一项保存完后跳转
			if (this.prevSubmit) {
				this.sourceIndex = this.sourceIndex - 1;

				console.log(this.sourceIndex);
				const source = this.sourceList[this.sourceIndex].source;
				this.$router.push({
					name: 'questionnaireDataStatisticsEdit',
					params: {
						id: this.surveyId,
						source: source,
						handle: 'show',
					},
				});
				this.$refs.questionnairePreview.createdHandle();
				this.isHandle = true;
			}
			// this.$refs.questionnairePreview.createdHandle();
			this.isHandle = true;
			this.nextSubmit = false;
			this.prevSubmit = false;
			this.dialogVisible = false;
		},
		//取消保存
		cancelSave() {
			this.dialogVisible = false;
			this.$refs.questionnairePreview.createdHandle();
			this.isHandle = true;
		},
		//点击编辑事件
		editHandle() {
			this.isHandle = false;
		},
		//下一项
		nextHandle() {
			console.log(this.sourceIndex, this.sourceList.length);
			if (this.sourceIndex >= this.sourceList.length - 1) {
				this.$message.warning('已经是最后一项了');
				return true;
			} else {
				if (!this.isHandle) {
					this.dialogVisible = true;
					this.nextSubmit = true;
				} else {
					this.sourceIndex = this.sourceIndex + 1;
					console.log(this.sourceIndex);
					const source = this.sourceList[this.sourceIndex].source || this.sourceList[this.sourceIndex].id;
					// console.log(this.sourceList)
					// console.log(index)
					// console.log(source)
					this.$router.push({
						name: 'questionnaireDataStatisticsEdit',
						params: {
							id: this.surveyId,
							source: source,
							handle: 'show',
						},
					});
					this.$refs.questionnairePreview.createdHandle();
					this.isHandle = true;
				}
			}
		},
		//上一项
		prevHandle() {
			if (this.sourceIndex < 1) {
				this.$message.warning('已经是第一项了');
				return true;
			} else {
				if (!this.isHandle) {
					this.dialogVisible = true;
					this.prevSubmit = true;
				} else {
					this.sourceIndex = this.sourceIndex - 1;

					console.log(this.sourceIndex);
					const source = this.sourceList[this.sourceIndex].source || this.sourceList[this.sourceIndex].id;
					// console.log(this.sourceList)
					// console.log(index)
					// console.log(source)
					this.$router.push({
						name: 'questionnaireDataStatisticsEdit',
						params: {
							id: this.surveyId,
							source: source,
							handle: 'show',
						},
					});
					this.$refs.questionnairePreview.createdHandle();
					this.isHandle = true;
				}
			}
		},
	},
};
</script>
<style lang="less">
#questionnaireDataStatisticsEdit {
	width: 100%;
	box-sizing: border-box;
	height: 100%;
	.layout-content {
		height: 100%;
		.layout-content-title {
			position: relative;
			z-index: 10;
			height: 64px;
			padding: 16px 16px 16px 24px;
			font-size: 14px;
			box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
			display: flex;
			justify-content: space-between;
			align-items: center;
			.breadcrumb {
				display: flex;
				align-items: center;
				.iconpark-icon {
					font-size: 20px;
					margin-right: 16px;
					cursor: pointer;
				}
				.el-breadcrumb__inner {
					color: rgba(29, 33, 41, 1);
					font-size: 18px;
					&.is-link {
						color: rgba(134, 144, 156, 1);
						font-weight: normal;
					}
				}
				.el-breadcrumb__separator {
					font-size: 16px;
				}
			}
		}
		.layout-container {
			box-sizing: border-box;
			height: calc(100% - 64px);
			padding: 32px 0 90px;
			background: rgba(242, 243, 245, 1);
			overflow: auto;
		}
	}
	.footer {
		width: 100vw;
		height: 60px;
		background-color: rgba(0, 0, 0, 0.5);
		position: fixed;
		bottom: 0;
		left: 0;
		display: flex;
		z-index: 999;
		box-sizing: border-box;
		padding: 10px 0 10px 199px;
		.footerContent {
			width: calc(100% - 16px);
			text-align: center;
			.footerContentInner {
				margin: 0 61px;
				display: inline-block;
				height: 100%;

				width: 100%;
				max-width: 900px;

				.left {
					padding: 0;
					display: inline-block;
					text-align: left;
					width: 50%;
					.el-button {
						width: 100px;
						&:nth-last-child {
							color: red;
						}
					}
				}
				.right {
					padding: 0;
					text-align: right;
					width: 50%;
					display: inline-block;
					.icon1 {
						width: 14px;
						height: 7px;
						color: #8a9099;
						position: relative;
						top: -3px;
					}
					p {
						float: right;
						height: 30px;
						width: 80px;
						padding: 2px 5px;
						text-align: center;
						cursor: pointer;
						line-height: 30px;
						background: #fff;
						margin: 5px 10px;
						border-radius: 5px;
						font-size: 14px;
						&:first-child {
							margin-right: 0px;
						}
					}
				}
			}
		}
	}
	.el-dialog {
		.el-dialog__body {
			padding-left: 60px;
		}
	}
}
</style>
